import fp from "lodash/fp";

import { mapOwnerToApi } from "mappers";

export default function mapPrincipalForm(form) {
	if (fp.isEmpty(form)) return;
	const signerExists = form?.ownerPrincipalSection?.signer?.id;

	const owner1 = mapOwnerToApi(form?.ownerPrincipalSection?.owners[0]);
	const owner2 = form?.ownerPrincipalSection?.owners[1]
		? mapOwnerToApi(form?.ownerPrincipalSection?.owners[1])
		: null;
	const owner3 = form?.ownerPrincipalSection?.owners[2]
		? mapOwnerToApi(form?.ownerPrincipalSection?.owners[2])
		: null;
	const owner4 = form?.ownerPrincipalSection?.owners[3]
		? mapOwnerToApi(form?.ownerPrincipalSection?.owners[3])
		: null;
	const authorizedSigner = signerExists
		? mapOwnerToApi(form?.ownerPrincipalSection?.signer)
		: null;

	const principalModel = {
		...form,
		...form.ownerPrincipalSection,
		owner1,
		owner2,
		owner3,
		owner4,
		authorizedSigner,
		primaryContact: {
			firstName: form?.firstName,
			phone: form?.phone,
			lastName: form?.lastName,
			email: form?.email,
			titlePosition: form?.titlePosition,
		},
		ownerPrincipalSection: undefined,
	};

	delete principalModel.owners;
	delete principalModel.signer;

	return principalModel;
}
